import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SHARED_ENVIRONMENT } from '@k12/environment';

export interface CountyResponse {
  id: string;
  name: string;
  ordinal?: number;
}

@Injectable({
  providedIn: 'root'
})
export class CountiesService {

  private readonly http: HttpClient = inject(HttpClient);
  private readonly sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private readonly apiUrl = this.sharedEnvironment.adminApiUrl;

  getCountiesByState(state: string): Observable<CountyResponse[]> {
    const params = new HttpParams().set('state', state);

    return this.http.get<CountyResponse[]>(
      `${this.apiUrl}/valueList/CountyList`,
      { params }
    );
  }
}
